import axios from "axios";
import { GMB } from "../../../services/gmbApiConfig";
import Cookies from "js-cookie";

export const uploadPostImagesToS3 = async ({ presignedUrl, file }) => {
  try {
    const formData = new FormData();
    Object.entries(presignedUrl.fields).forEach(([key, value]) => {
      formData.append(key, value);
    });
    formData.append("file", file);
    console.log({ formData });

    const response = await axios.post(presignedUrl.url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    console.log(" uploadImageToS3 response", response);
    return response;
  } catch (error) {
    throw new Error("Failed to upload image to S3");
  }
};
